import { render, staticRenderFns } from "./DefaultEmployeeCardSection.vue?vue&type=template&id=1fab8ee7&"
import script from "./DefaultEmployeeCardSection.vue?vue&type=script&lang=js&"
export * from "./DefaultEmployeeCardSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports